import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LetteraDiffida } from '../../../models/lettera-diffida';

@Component({
    selector: '[add_doc_to_lettera_diffida]',
  templateUrl: 'add-to-lettera-diffida.component.html',
})

export class AddDocumentoToLetteraDiffidaComponent {
  @Input()
  letteraDiffida: LetteraDiffida;

  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(letteraDiffida: LetteraDiffida) {
    this.onClickAddToEntity.emit(letteraDiffida);
  }
}
